// extracted by mini-css-extract-plugin
export default {"container":"SearchFeed_container__jwUS3","searchTerm":"SearchFeed_searchTerm__Sv8zN","resultsContainer":"SearchFeed_resultsContainer__pBKVD"};